<template>
  <div class="max-w-2xl mx-auto py-8 px-4">
    <h2 class="text-2xl font-bold mb-6">Information importante concernant votre contrat</h2>

    <div class="space-y-6">
      <section>
        <h3 class="text-lg font-semibold mb-2">Ce qui s'est passé</h3>
        <p class="text-gray-600">
          <span class="font-bold">MMA IARD (groupe Covéa)</span>
          , qui portait votre contrat d'assurance vélo, a décidé de résilier l'ensemble des contrats collectifs
          affinitaires qui le liaient à Estaly, pour des raisons propres à sa politique de souscription. Cette décision,
          que nous avons contestée, a pris effet le
          <span class="font-bold">31 décembre 2025</span>
          .
        </p>
      </section>

      <section>
        <h3 class="text-lg font-semibold mb-2">Ce que nous avons fait</h3>
        <p class="text-gray-600">
          Pour éviter toute rupture de couverture, nous avons négocié un nouveau contrat auprès d'
          <span class="font-bold">Acheel SA</span>
          (agréée par l'ACPR). Ce contrat a pris effet dès le
          <span class="font-bold">1er janvier 2026</span>
          et couvre les principaux risques de casse accidentelle et de vol de votre vélo.
        </p>
      </section>

      <Alert type="error">
        <template #title>Point d'attention important</template>
        la
        <span class="font-bold">garantie vol partiel</span>
        (vol d'accessoires et de composants sans vol du vélo complet)
        <span class="font-bold">n'est plus couverte</span>
        par le nouveau contrat Acheel, alors qu'elle l'était dans l'ancien contrat MMA.
      </Alert>

      <section>
        <h3 class="text-lg font-semibold mb-2">Ce qui change</h3>
        <p class="text-gray-600">
          Outre la suppression de la garantie vol partiel mentionnée ci-dessus, les conditions de marché consécutives au
          retrait de MMA ont entraîné une modification de certaines conditions d'indemnisation, notamment les
          <span class="font-bold">franchises</span>
          et le
          <span class="font-bold">calcul de la vétusté</span>
          . Nous vous devons la transparence sur ces changements.
        </p>
      </section>

      <Alert type="warning">
        Vous avez
        <span class="font-bold">{{ remainingDays }} jours pour vous prononcer</span>
        . Sans action de votre part à cette date, votre police individuelle sera
        <span class="font-bold">automatiquement résiliée</span>
        et vos cotisations remboursées au prorata.
      </Alert>
    </div>

    <div class="mt-8">
      <PrimaryButton @click="$emit('next')">VOIR LE DÉTAIL DES CHANGEMENTS ET CONFIRMER MON CHOIX &rarr;</PrimaryButton>
    </div>
  </div>
</template>

<script>
import { Alert, PrimaryButton } from "@estaly/ui";

export default {
  components: { Alert, PrimaryButton },

  props: {
    remainingDays: {
      type: Number,
      required: true,
    },
  },

  emits: ["next"],
};
</script>
